import {get} from 'lodash';

export default (state = {}, payload: any) => {
  const {stateName = '', stateValue = ''} = payload || {};
  if (!stateName) return state;

  return {
    ...state,
    viewTeamsState: {
      ...get(state, 'viewTeamsState', {}),
      [stateName]: stateValue,
    },
  };
};
